<div style="width: 100%; margin-bottom: 12px">
    <mat-card>
        <div class="one-row">
            <h5>Lieferanten und Einkaufspreise</h5>
            <span class="spacer"></span>
            <button
                mat-icon-button
                color="accent"
                (click)="openDetailsDialog()"
                [disabled]="disabled"
                *kienePermission="[1601]"
                [attr.data-cy]="'wsmsm_button_1_0_'"
                ><mat-icon [attr.data-cy]="'wsmsm_mat-icon_1_2_'">add</mat-icon></button
            >
        </div>

        <table class="phito-table" [style.color]="disabled ? 'lightgray' : ''">
            <thead>
                <tr>
                    <th>Pos.</th>
                    <th>Lieferant</th>
                    <th *kienePermission="[1600]">Preis</th>
                    <th *kienePermission="[1600]">Rabatt (%)</th>
                    <th *kienePermission="[1600]">Rabatt. Preis</th>
                    <th *kienePermission="[1600]">Skonto (%)</th>
                    <th>Zahlungsziel (Tage)</th>
                    <th>Standardlieferant</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let sm of supplierMaterials; let i = index">
                    <td [attr.data-cy]="'wsmsm_td_1_5_' + i">{{ i + 1 }}</td>
                    <td [attr.data-cy]="'wsmsm_td_2_5_' + i">{{ sm.lieferant }}</td>
                    <td *kienePermission="[1600]" [attr.data-cy]="'wsmsm_td_3_5_' + i"
                        >{{ sm.einzelpreis | number: "1.2-2" }} &euro;</td
                    >
                    <td *kienePermission="[1600]" [attr.data-cy]="'wsmsm_td_4_5_' + i">{{ sm.rabatt }} &#37;</td>
                    <td *kienePermission="[1600]" [attr.data-cy]="'wsmsm_td_5_5_' + i"
                        >{{ gibRabattiertenPreis(sm) | number: "1.2-2" }} &euro;</td
                    >
                    <td *kienePermission="[1600]" [attr.data-cy]="'wsmsm_td_6_5_' + i">{{ sm.skonto }} &#37;</td>
                    <td [attr.data-cy]="'wsmsm_td_7_5_' + i">{{ sm.zahlungsziel }}</td>
                    <td [attr.data-cy]="'wsmsm_td_8_5_' + i"
                        ><mat-icon color="accent" [attr.data-cy]="'wsmsm_mat-icon_2_2_' + i">{{
                            sm.standard_lieferant ? "check_box" : "check_box_outline_blank"
                        }}</mat-icon></td
                    >
                    <td [attr.data-cy]="'wsmsm_td_9_5_'">
                        <button
                            mat-icon-button
                            [matMenuTriggerFor]="menu"
                            [disabled]="disabled"
                            [attr.data-cy]="'wsmsm_button_2_0_' + i"
                        >
                            <mat-icon [attr.data-cy]="'wsmsm_mat-icon_3_2_' + i">more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button
                                mat-menu-item
                                (click)="openDetailsDialog(sm)"
                                *kienePermission="[1601]"
                                [attr.data-cy]="'wsmsm_button_3_0_' + i"
                            >
                                <mat-icon [attr.data-cy]="'wsmsm_mat-icon_4_2_' + i">edit</mat-icon>
                                <span [attr.data-cy]="'wsmsm_span_2_6_' + i">Bearbeiten</span>
                            </button>
                            <button
                                mat-menu-item
                                (click)="openDeleteDialog(sm)"
                                [attr.data-cy]="'wsmsm_button_4_0_' + i"
                            >
                                <mat-icon [attr.data-cy]="'wsmsm_mat-icon_5_2_' + i">delete</mat-icon>
                                <span [attr.data-cy]="'wsmsm_span_3_6_' + i">L&ouml;schen</span>
                            </button>
                            <button
                                *ngIf="isAdmin"
                                mat-menu-item
                                (click)="openHistorieDialog(sm)"
                                [attr.data-cy]="'wsmsm_button_5_0_' + i"
                            >
                                <mat-icon [attr.data-cy]="'wsmsm_mat-icon_6_2_' + i">history</mat-icon>
                                <span [attr.data-cy]="'wsmsm_span_4_6_' + i">Historie anzeigen</span>
                            </button>
                        </mat-menu>
                    </td>
                </tr>
            </tbody>
        </table>
    </mat-card>
</div>
